import { useRef } from "react";

type noop = (...args: any[]) => any;

export function usePersistFn<T extends noop>(fn: T) {
  const fnRef = useRef<T | null>(null);
  fnRef.current = fn;

  const persistFn = useRef<T | null>(null);

  if (!persistFn.current) {
    persistFn.current = function (this: unknown, ...args: Parameters<T>) {
      const currentFn = fnRef.current;
      if (!currentFn) {
        throw new Error("usePersistFn called before initialization");
      }
      return currentFn.apply(this, args);
    } as T;
  }

  return persistFn.current;
}
